import { useFormik } from "formik";
import React, { useState } from "react";
import * as YUP from "yup";
import { Link, useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import axios from "axios";
import submitImg from "../../Assets/Post3.65b1272ac4b291.79834324.png";
import "./Register.css";
import { Helmet } from "react-helmet";

export default function Register() {
  const [passwordVisible, setPasswordVisible] = useState(false);
  
  const togglePasswordVisibility = () => {
    setPasswordVisible(prevState => !prevState);
  };
  let phoneRegex = /^\+([1-9][0-9]{0,2})([0-9]{9,11})$/;
  let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  let validationSchema = YUP.object({
    name: YUP.string()
      .min(3, "Name must be at least 3 character")
      .required("Name is required"),
    mobile: YUP.string()
      .matches(phoneRegex, "Phone is invalid, Phone must Start with +")
      .required("Phone is required"),
    email: YUP.string()
      .matches(emailRegex, "Email is not matched, Please try again!")
      .required("Email is required"),
    password: YUP.string()
      .min(6, "Password must be at least 6 character")
      .required("Password isrequired"),
  });

  let navigate = useNavigate();
  const [error, seterror] = useState(null);
  const [isLodding, setisLodding] = useState(false);

  async function submitRegister(values) {
    setisLodding(true);
    let { data } = await axios
      .post("https://vehex-production.up.railway.app/user/register", values)
      .catch((err) => {
        setisLodding(false);
        seterror(err.response.data.message);
      });
    if (data.message === "User registered successfully") {
      setisLodding(false);
      navigate("/login");
    }
  }

  let register = useFormik({
    initialValues: {
      name: "",
      mobile: "",
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: submitRegister,
  });

  return (
    <>
                                        <Helmet>
                      <title>Register</title>
                    </Helmet>
      <div className="w-100 bg-black">
        <div className="image w-100 position-relative">
          <div className="overlay">
            <div className="container">
              <div className="w-50 py-4 submitContent box-shadow p-2 mt-2 position-absolute rounded-3">
                {error ? (
                  <div className="alert alert-danger">{error} try again!</div>
                ) : (
                  ""
                )}

                <h2 className="fw-600 mb-3 heading">Register Now</h2>
                <form onSubmit={register.handleSubmit}>
                  <label htmlFor="name" className="fs-4 second-color">
                    Name :
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-control fs-5"
                    value={register.values.name}
                    onBlur={register.handleBlur}
                    onChange={register.handleChange}
                  ></input>
                  {register.errors.name && register.touched.name ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {register.errors.name}
                    </div>
                  ) : (
                    " "
                  )}

                  <label htmlFor="mobile" className="fs-4 second-color mt-3">
                    Phone :
                  </label>
                  <input
                    type="tel"
                    id="mobile"
                    name="mobile"
                    className="form-control fs-5"
                    value={register.values.mobile}
                    onBlur={register.handleBlur}
                    onChange={register.handleChange}
                  ></input>
                  {register.errors.mobile && register.touched.mobile ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {register.errors.mobile}
                    </div>
                  ) : (
                    " "
                  )}

                  <label htmlFor="email" className="fs-4 second-color mt-3">
                    Email :
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control fs-5"
                    value={register.values.email}
                    onBlur={register.handleBlur}
                    onChange={register.handleChange}
                  ></input>
                  {register.errors.email && register.touched.email ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {register.errors.email}
                    </div>
                  ) : (
                    ""
                  )}

                  <label htmlFor="password" className="fs-4 second-color mt-3">
                    Password :
                  </label>
                  <div className="input-group">
                    <input
                      type={passwordVisible ? 'text' : 'password'}
                      id="password"
                      name="password"
                      className="form-control fs-5"
                      value={register.values.password}
                      onBlur={register.handleBlur}
                      onChange={register.handleChange}
                    ></input>
                    <span className="input-group-text" onClick={togglePasswordVisibility} style={{ cursor: 'pointer' }}>
                          <i className={passwordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'}></i>
                    </span>
                  </div>
                  {register.errors.password && register.touched.password ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {register.errors.password}
                    </div>
                  ) : (
                    ""
                  )}

                  {isLodding ? (
                    <button type="button" className="btn text-white py-3">
                      <RotatingLines
                        strokeColor="#c2272d"
                        strokeWidth="10"
                        animationDuration="1"
                        width="30"
                        visible={true}
                      />
                    </button>
                  ) : (
                    <>
                      <div className="d-flex justify-content-between align-items-center">
                        <button
                          disabled={!(register.isValid && register.dirty)}
                          type="submit"
                          className="my-3 border-2 me-2 fw-600"
                        >
                          Register
                        </button>
                        <div className="light-color fs-6 question">
                          Do you have an email?{" "}
                          <Link
                            className="mx-1 second-color fs-6"
                            to={"/login"}
                          >
                            Login Now
                          </Link>
                        </div>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
